(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-menu/assets/javascripts/competition-menu-provider.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-menu/assets/javascripts/competition-menu-provider.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const NavMenu = svs.components.marketplaceCompetition.navMenu.NavMenu;
const CompetitionMenuContext = svs.components.marketplaceCompetition.competitionMenu.CompetitionMenuContext;
const CompetitionMenuProvider = _ref => {
  let branding = _ref.branding,
    children = _ref.children,
    items = _ref.items,
    relativeTo = _ref.relativeTo;
  const value = useMemo(() => ({
    competitionMenu: React.createElement(NavMenu, {
      branding: branding,
      menuItems: items,
      relativeTo: relativeTo
    })
  }), [branding, items, relativeTo]);
  return React.createElement(CompetitionMenuContext.Provider, {
    value: value
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.competitionMenu.CompetitionMenuProvider', CompetitionMenuProvider);

 })(window);